export const FormField = ({ label, error, testId, children }) => (
  <label className="block">
    <span className="mb-1.5 block text-sm font-medium text-slate-700">{label}</span>
    {children}
    {error && (
      <span className="mt-1.5 block text-xs text-red-500" data-testid={`${testId}-error`} role="alert">
        {error}
      </span>
    )}
  </label>
);